import PropTypes from 'prop-types';
import {appConfigService} from '_app/services';
import './disclaimer.less';

export const Disclaimer = ({advisorDisclaimer, versionDisclaimer, complianceID, officeFooter}) => {
	return (
		<div className="print-compliance-disclaimer-text">
			{advisorDisclaimer &&
                <div className="compliance-text" dangerouslySetInnerHTML={getAdvisorDisclaimer(advisorDisclaimer)} />
			}
			{versionDisclaimer &&
                <div className="compliance-text">{versionDisclaimer}</div>
			}
			{complianceID &&
                <div className="compliance-text">{complianceID}</div>
			}
			{officeFooter &&
                <div className="compliance-text" dangerouslySetInnerHTML={getOfficeFooter(officeFooter)} />
			}
		</div>
	);
};

Disclaimer.propTypes = {
	advisorDisclaimer: PropTypes.string,
	versionDisclaimer: PropTypes.string,
	officeFooter: PropTypes.string,
	complianceID: PropTypes.string,
	isVideo: PropTypes.bool
};

export const getAdvisorDisclaimer = (advisorDisclaimer) => {
	return {
		__html: advisorDisclaimer.replace('<img src="/',`<img src="${appConfigService.get('baseDomainName')}/`)
	};
};

export const getOfficeFooter = (officeFooter) => {
	return {
		__html: officeFooter
	};
};